import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Table from 'components/common/Table/Table'
import Image from 'components/common/Image'
import tireImage from '../assets/tire-image.jpg'

const TrailerTireLine = ({ tireLineName, tires }) =>
  <Wrapper>
    <TableImage aria-hidden="true">
      <TableImageHeader>{ tireLineName }</TableImageHeader>
      {
        tireImage &&
        <ImageItem>
          <TireImage src={ tireImage } alt={ `${tireLineName} tire` } />
        </ImageItem>
      }
    </TableImage>
    <TableWrapper>
      <Table.Table>
        <caption data-sr-only>{ tireLineName }</caption>
        <thead>
          <Table.Row header>
            <TableHeader nowrap scope="col">Size</TableHeader>
            <TableHeader scope="col">Speed Rating</TableHeader>
            <TableHeader scope="col">Load Index</TableHeader>
            <TableHeader scope="col">Ply Rating</TableHeader>
            <TableHeader scope="col">Single Load</TableHeader>
            <TableHeader scope="col">Dual Load</TableHeader>
            <TableHeader scope="col">Outside Diameter</TableHeader>
          </Table.Row>
        </thead>
        <tbody>
          {
            (tires || []).map(({
              size,
              speedRating,
              loadIndex,
              plyRating,
              singleLoad,
              dualLoad,
              outsideDiameter
            }) =>
              <Table.Row zebra key={ size }>
                <TableHeader scope="row">{ size }</TableHeader>
                <Cell>{ speedRating }</Cell>
                <Cell>{ loadIndex }</Cell>
                <Cell>{ plyRating }</Cell>
                <Cell>{ singleLoad }</Cell>
                <Cell>{ dualLoad }</Cell>
                <Cell>{ outsideDiameter }</Cell>
              </Table.Row>
            )
          }
        </tbody>
      </Table.Table>
    </TableWrapper>
  </Wrapper>

export default TrailerTireLine

TrailerTireLine.propTypes = {
  tireLineName: PropTypes.string,
  tires: PropTypes.arrayOf(PropTypes.shape({
    size: PropTypes.string,
    speedRating: PropTypes.string,
    loadIndex: PropTypes.string,
    plyRating: PropTypes.string,
    singleLoad: PropTypes.string,
    dualLoad: PropTypes.string,
    outsideDiameter: PropTypes.string
  }))
}

const Wrapper = styled.div`
  margin-left: 16px;
  overflow-x: auto;
  ${Media.desktop`
    margin: 0 auto;
  `}

  & + & {
    ${Mixin.responsive('margin-top', '47px', '28px')}
  }
`

const Cell = styled(Table.Cell)`
  font-weight: 600;
  line-height: 19px;
  vertical-align: middle;
  ${Mixin.responsive('padding', '15px 10px', '15px 7px')}
`

const ImageItem = styled.div`
  padding: 10px;
  vertical-align: middle;
  height: 170px;
`

const TableHeader = styled(Table.Header)`
  white-space: nowrap;
  ${Media.mobile`
    min-width: 115px;
  `}

  ${Mixin.responsive('padding', '10px', '10px 7px')}
  ${props => props.width && css`
    min-width: 191px;
    ${Mixin.responsive('padding-left', '20px', '10px')}
    ${Media.mobile`
      white-space: nowrap;
    `}
  `}

  &:last-child {
    ${Media.mobile`
      min-width: 135px;
    `}
  }

  ${props => props.scope === 'row' && css`
    padding: 15px 7px;
    font-weight: 600;
    white-space: normal;
  `}
`

const TireImage = styled(Image)`
  width: 100px;
  height: auto;
  margin: 0 auto;
  display: block;
`

const TableImage = styled.div`
  display: table-cell;
  vertical-align: top;
`

const TableWrapper = styled.div`
  display: table-cell;
`

const TableImageHeader = styled.div`
  background-color: ${Theme.colors.dark_grey};
  color: ${Theme.colors.white};
  text-align: left;
  white-space: nowrap;
  ${Media.desktop`
    font-weight: 600;
    min-width: 191px;
  `}
  ${Mixin.responsive('padding', '10px', '10px 7px')}
  ${Mixin.responsive('padding-left', '20px', '10px')}
`
